import {
  Component,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'ui-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent {
  @Input() content: TemplateRef<any>;
  @Input() tabs: { label: string; value: string; isActive: boolean }[];

  @Output() selected: EventEmitter<string> = new EventEmitter();

  clicked(tab: string) {
    this.selected.emit(tab);
  }
}
